// extracted by mini-css-extract-plugin
export var body = "Z_c";
export var footer = "Z_ch";
export var footerText = "Z_cj";
export var section = "Z_d";
export var title = "Z_h";